import { Injectable } from '@angular/core';

export interface BadgeItem {
    type: string;
    value: string;
}

export interface ChildrenItems {
    state: string;
    target?: boolean;
    name: string;
    type?: string;
    children?: ChildrenItems[];
}

export interface MainMenuItems {
    state: string;
    main_state?: string;
    target?: boolean;
    name: string;
    type: string;
    icon: string;
    badge?: BadgeItem[];
    children?: ChildrenItems[];
}

export interface Menu {
    label: string;
    main: MainMenuItems[];
}
const MENUITEMS = [
    {
        label: 'Inicio',
        main: [
            {
                state: 'dashboard',
                name: 'Dashboard',
                type: 'link',
                icon: 'ti-home'
            }
        ]
    },
    {
        label: 'Menú General',
        main: [
            {
                state: 'perfil',
                name: 'Perfil Cliente',
                type: 'sub',
                icon: 'ti-user',
                children: [
                    {
                        state: 'detalle',
                        name: 'Datos generales',
                        type: 'link',
                        icon: 'ti-receipt'
                    }
                ]
            },
            {
                state: 'cotizacion',
                name: 'Solicitar Prendas',
                type: 'sub',
                icon: 'ti-hand-open',
                children: [
                    {
                        state: 'create',
                        name: 'Solicitar',
                        type: 'link',
                        icon: 'ti-layout-accordion-merged',
                        reload: true
                    }
                ]

            },
            {
                state: 'cotizacion',
                name: 'Cotizaciones',
                type: 'sub',
                icon: 'ti-briefcase',
                children: [
                    {
                        state: 'listado-cotizaciones',
                        name: 'Listado de cotizaciones',
                        type: 'link',
                        icon: 'ti-layout-accordion-merged'
                    }

                ]

            },
            {
                state: 'materiales',
                name: 'Órdenes de Producción',
                type: 'sub',
                icon: 'ti-package',
                children: [
                    {
                        state: 'materiales',
                        name: 'Ver listado de OP',
                        type: 'link',
                        icon: 'ti-layout-accordion-merged'
                    }/*,
                    {
                        state: 'compra',
                        name: 'Ver listado de Remisiones de una OP',
                        type: 'link',
                        icon: 'ti-layout-accordion-merged'
                    } */

                ]

            },
            {
                state: 'invoice',
                name: 'Facturas',
                type: 'sub',
                icon: 'ti-receipt',
                children: [
                    {
                        state: 'facturas',
                        name: 'Listado',
                        type: 'link',
                        icon: 'ti-clipboard'
                    }

                ]

            },
            {

                state: 'authentication',
                name: 'Salir',
                type: 'link',
                icon: 'ti-na'
            }
        ]
    }
];

@Injectable()
export class MenuItems {
    getAll(): Menu[] {
        return MENUITEMS;
    }
}



// WEBPACK FOOTER //
// /Users/clgingeniero/Documents/Proyectos/Impel/acertar/src/app/shared/menu-items/menu-items.ts